"use client";

import SortingControls from "@/components/cars/SortingControls";
import { useMobileFilter } from "@/components/cars/MobileFilterProvider";

/**
 * Sticky controls row for collection pages: mobile filter toggle + sorting.
 * The SRP gets these from TopSearchBar; collections skip the keyword search
 * box (keyword search runs against all inventory, not a segment).
 */
export default function CollectionControlsBar() {
    const { showMobileFilters, setShowMobileFilters } = useMobileFilter();

    return (
        <div className="t-bg-white t-border-b t-border-gray-200">
            <div className="t-px-4 sm:t-px-6 lg:t-px-8 t-py-3 t-flex t-flex-wrap sm:t-flex-nowrap t-justify-between t-items-center t-gap-3">
                <button
                    className="lg:t-hidden t-flex t-items-center t-gap-2 t-px-4 t-py-2 t-rounded-none t-min-h-11 t-whitespace-nowrap t-bg-brand-violet t-text-white t-shadow-card t-border-2 t-border-brand-violet hover:t-bg-brand-violet-dark focus-visible:t-outline-none focus-visible:t-ring-2 focus-visible:t-ring-brand-violet focus-visible:t-ring-offset-2 hover:t-shadow-card-hover t-transition-all t-duration-200"
                    onClick={() => setShowMobileFilters(true)}
                    type="button"
                    aria-haspopup="dialog"
                    aria-expanded={showMobileFilters}>
                    <svg className="t-w-5 t-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                        />
                    </svg>
                    <span className="t-text-sm t-font-semibold">Shop Your Way</span>
                </button>
                <div className="t-hidden lg:t-block" />
                <div className="t-ml-auto t-flex-shrink-0">
                    <SortingControls />
                </div>
            </div>
        </div>
    );
}
